const initialState = {
  patchScanDeviceStatusArr: [],
};

export default function filtersReducer(state = initialState, action) {
  switch (action.type) {
    case "UPDATE_PATCH_SCAN_DEVICE_STATUS": {
      let ns = {
        ...state,
      };

      ns.patchScanDeviceStatusArr = action.data.patchScanDeviceStatusArr;

      return ns;
    }
    default:
      return state;
  }
}

export function updatePatchScanDeviceStatus({
  deviceDetailsArr,
  ...deviceStatus
}) {
  const store = window.store;
  if (!store) return;

  const currentArr = store.getState().patch.patchScanDeviceStatusArr;
  let nextArr = [...currentArr];

  if (deviceDetailsArr) {
    for (let i = 0; i < deviceDetailsArr.length; i++) {
      const currentIncomingDevice = deviceDetailsArr[i];

      if (
        !currentIncomingDevice ||
        Number.isNaN(Number(currentIncomingDevice.deviceId)) ||
        !currentIncomingDevice.scanStatus
      )
        continue;

      const existingIndex = currentArr.findIndex(
        (device) =>
          String(device.deviceId) === String(currentIncomingDevice.deviceId),
      );

      if (existingIndex === -1) {
        nextArr = [...nextArr, currentIncomingDevice];
      } else {
        nextArr[existingIndex] = currentIncomingDevice;
      }
    }
  }

  if (deviceStatus?.deviceId !== undefined && deviceStatus?.deviceId !== null) {
    const existingIndex = currentArr.findIndex(
      (device) => String(device.deviceId) === String(deviceStatus.deviceId),
    );

    if (existingIndex === -1) {
      nextArr = [...nextArr, deviceStatus];
    } else {
      nextArr[existingIndex] = deviceStatus;
    }
  }

  store.dispatch({
    type: "UPDATE_PATCH_SCAN_DEVICE_STATUS",
    data: { patchScanDeviceStatusArr: nextArr },
  });
}
